export default __webpack_public_path__ + "static/media/map_marker.ec907e54.svg";